module.exports = __webpack_public_path__ + "static/media/logo.e64b157f.svg";